import { PO_STATUS } from './po-queries';

export const getThemeByStatus = (status: PO_STATUS) => {
  if (status === PO_STATUS.ASSIGNED) return 'yellow';
  if (status === PO_STATUS.SUBMITTED) return 'green';
  if (status === PO_STATUS.CANCELLED) return 'red';
  return 'grey';
};

export const translateStatusLabel = (status: string): string => {
  if (status === PO_STATUS.ASSIGNED) return 'PO Assigned';
  if (status === PO_STATUS.SUBMITTED) return 'Order Created';
  if (status === 'NOT SUBMITTED') return 'Not Assigned';
  return status;
};
